var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid task-images-container"},[(_vm.galleryOptions !== null)?_c('input',{directives:[{name:"file-uploader",rawName:"v-file-uploader",value:(_vm.galleryOptions),expression:"galleryOptions"}],staticClass:"gallery_media",attrs:{"type":"file","name":"files"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }